import { createApp } from 'vue'
import FInputPassword from '~/js/components/inputPassword'
import { getParam } from '~/js/helpers/url-helper'
import { Password } from '~/js/models/password'

const ID_ACTIVATE_ACCOUNT = 'js-customers-activate-account'
export const KEY_SET_ACCEPTS_MARKETING = 'setAcceptsMarketing'

document.addEventListener('DOMContentLoaded', () => {
  const elementActivateAccount = document.getElementById(ID_ACTIVATE_ACCOUNT)
  if (!elementActivateAccount) return

  const isYappli = getParam('is_yappli') === 'true'
  if (isYappli)
    window.location.href = `franc-app:/tab/custom/3d9487ce?url=${encodeURI(
      window.location.href
    )}`
  const email = getParam('email')

  createApp({
    name: 'TemplatesCustomersActivateAccount',
    components: {
      FInputPassword,
    },
    data() {
      return {
        email,
        errorMessages: { password: '', passwordConfirm: '' },
        password: '',
        passwordConfirm: '',
      }
    },
    methods: {
      onSubmit($event) {
        this.errorMessages = new Password().getErrorMessages(
          this.password,
          this.passwordConfirm
        )
        if (!Object.values(this.errorMessages).filter((v) => v).length) {
          const acceptsMarketing = $event.target.form.querySelector(
            'input[name="acceptsMarketing"]'
          ).checked
          sessionStorage.setItem('setAcceptsMarketing', acceptsMarketing)
          $event.target.form.submit()
        }
      },
    },
  }).mount(elementActivateAccount)
})
